import { useEffect, useRef, useState } from "react";
import ActivityCard from "./ActivityCard";
import { useTranslation } from "react-i18next";

// `refreshSignal` (opzionale): incrementalo per forzare un nuovo fetch delle "ultime 5"
// (usato dal pull-to-refresh della Home).
export default function LastFiveSection({ refreshSignal = 0 }) {
    const { t, i18n } = useTranslation();
    const [lastFive, setLastFive] = useState(null);
    const scrollContainerRef = useRef(null);
    const getLastFive = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/activities/get-last-five?lang=${i18n.language}`, {
                method: 'GET',
                headers: {
                    'Content-Type': "application/json",
                }
            });
            if (response.ok) {
                const result = await response.json();
                setLastFive(result.payload);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getLastFive();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language, refreshSignal]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const handleWheel = (e) => {
            // Se c'è già movimento orizzontale (touch/trackpad), lascia che funzioni normalmente
            if (e.deltaX !== 0) {
                // Non fare preventDefault(), lascia che il browser gestisca lo scroll orizzontale nativo
                return;
            }

            // Se c'è solo movimento verticale, convertilo in orizzontale
            if (Math.abs(e.deltaY) > 0) {
                e.preventDefault();
                container.scrollLeft += e.deltaY;
            }
        };

        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, [lastFive]);

    if (!lastFive || lastFive.length === 0) return null;

    return (
        <div className="w-full lg:w-[1000px] flex flex-col gap-2 mt-8">
            <h1 className="text-[#225424] hidden xl:block">{t('Homepage.LastFiveSection.title')}</h1>
            <h2 className="text-[#225424] hidden md:block xl:hidden">{t('Homepage.LastFiveSection.title')}</h2>
            <h3 className="text-[#225424] md:hidden">{t('Homepage.LastFiveSection.title')}</h3>
            <div ref={scrollContainerRef} className='w-full lg:w-[960px] flex gap-4 overflow-auto py-2 hide-scrollbar'>
                {
                    lastFive.map((element, index) => {
                        return <ActivityCard key={index} activityData={element} isFixedSize={true} />
                    })
                }
            </div>
        </div>
    )
}